import React, { useEffect } from "react";
import { useLang } from "@/i18n";
import XentraWidget from "@/components/XentraWidget";
import { PromoCard } from "@/components/PromoCard";

export default function Apartments() {
  const { t, lang } = useLang();

  useEffect(() => {
    document.title = `${t("apartments_title")} – Atlas Apartment`;
  }, [lang]);

  return (
    <div className="bg-[var(--cream)] min-h-screen">
      {/* Header */}
      <div className="bg-[var(--sage-dark)] pt-28 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="tag text-[var(--gold)]">{t("tag_all_locations")}</span>
          <h1 className="font-display text-5xl md:text-7xl font-medium text-white mt-2 mb-3">{t("apartments_title")}</h1>
          <p className="text-white/40 text-sm">{t("apartments_sub")}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10"><PromoCard /></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="rounded-[28px] border border-[var(--warm)] bg-white">
          <XentraWidget className="rounded-[28px]" />
        </div>
      </div>
    </div>
  );
}
